import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import styled from "styled-components";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

export const CardFooterWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${(props) => props.theme.spacing.medium} ${(props) => `calc(${props.theme.spacing.medium} - 2px)`};
    background: ${(props) => props.theme.colors[props.theme.colorMode].rain_Sub};
    margin: ${(props) => props.theme.spacing.large} 0 0 0;
    width: 100%;
    border-bottom-left-radius: ${(props) => `calc(${props.theme.cornerRadius.large} - 2px)`};
    border-bottom-right-radius: ${(props) => `calc(${props.theme.cornerRadius.large} - 2px)`};

    .invertedIcon {
        transform: rotate(180deg);
        margin-left: auto;
    }
`;

export const CardFooterContentWrapper = styled.section`
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.spacing.small};
`;

export const CardFooterTextContainer = styled.article`
    display: flex;
    flex-direction: column;
`;

export const Container = styled.div<{ isPHApplyCoupon?: boolean; isNewPORFlow?: boolean; showingCardFooter?: boolean }>(
    ({ theme, isPHApplyCoupon, isNewPORFlow, showingCardFooter }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: `${theme.spacing.xxLarge} ${theme.spacing.large} ${theme.spacing.large} ${theme.spacing.large}`,
        borderRadius: theme.cornerRadius.large,
        background: theme.colors[theme.colorMode].background_Primary,
        minWidth: "260px",
        position: "relative",
        ...(isPHApplyCoupon && {
            padding: theme.spacing.large,
        }),
        ...(isNewPORFlow && {
            padding: `${theme.spacing.xxLarge} ${theme.spacing.xxSmall} ${theme.spacing.large} ${theme.spacing.xxSmall}`,
        }),
        ...(showingCardFooter && {
            padding: `${theme.spacing.xxLarge} ${theme.spacing.xxSmall} ${theme.spacing.xxSmall} ${theme.spacing.xxSmall}`,
        }),
    }),
);

export const StyledImage = styled(Image)<{ isPHApplyCoupon?: boolean }>(({ isPHApplyCoupon }) =>
    isPHApplyCoupon
        ? {
              width: "135px",
              display: "block",
              margin: "0 auto",
          }
        : {
              width: "48px",
              position: "absolute",
              top: 0,
              left: "50%",
              transform: "translate(-50%, -50%)",
          },
);

export const CloseIconWrapper = styled.div(({ theme }) => ({
    position: "fixed",
    top: theme.spacing.small,
    right: theme.spacing.small,
}));

export const Title = styled(Text)<{ isNewPORFlow?: boolean }>(({ isNewPORFlow }) => ({
    textAlign: "center",
    alignSelf: "center",
    ...(isNewPORFlow && {
        textTransform: "uppercase",
    }),
}));

export const Subtitle = styled(Text)<{ noMarginTop?: boolean; isNewPORFlow?: boolean }>(
    ({ noMarginTop, isNewPORFlow, theme }) => ({
        textAlign: "center",
        marginTop: theme.spacing.xSmall,
        ...(isNewPORFlow && {
            marginTop: theme.spacing.large,
        }),
        ...(noMarginTop && {
            marginTop: theme.spacing.empty,
        }),
    }),
);

export const SecondarySavingsSubtitle = styled(Text)({
    textAlign: "center",
});

export const SecondaryDiscountCallout = styled(Text)(({ theme }) => ({
    textAlign: "center",
    marginTop: theme.spacing.xxxSmall,
}));

export const Description = styled(Text)<{ isNewPORFlow?: boolean }>(({ isNewPORFlow, theme }) => ({
    textAlign: "center",
    alignSelf: "center",
    marginTop: theme.spacing.xSmall,
    ...(isNewPORFlow && {
        margin: `6px ${theme.spacing.small} ${theme.spacing.empty} ${theme.spacing.small}}`,
    }),
}));

export const CTAWrapper = styled.div<{ isNewPORFlow?: boolean }>(({ isNewPORFlow, theme }) => ({
    width: isNewPORFlow ? "90%" : "100%",
    marginTop: isNewPORFlow ? theme.spacing.large : theme.spacing.xLarge,
}));

export const StyledSuperButton = styled(SuperButton)<{ backgroundColor?: keyof IColors }>(
    ({ backgroundColor, theme }) => ({
        ...(backgroundColor && {
            backgroundColor: theme.colors[theme.colorMode][backgroundColor],
        }),
        width: "100%",
    }),
);
